import React from 'react';
import { CheckIcon, PackageIcon } from 'lucide-react';
interface SKUCardProps {
  sku: {
    id: string;
    name: string;
    sku: string;
    price: number;
    stock: number;
    productName: string;
    brand: string;
    image: string;
  };
  isSelected: boolean;
  onToggleSelect: () => void;
}
export const SKUCard: React.FC<SKUCardProps> = ({
  sku,
  isSelected,
  onToggleSelect
}) => {
  return <div className={`bg-white border rounded-md overflow-hidden transition-all ${isSelected ? 'border-green-500 shadow-md' : 'border-gray-200 hover:border-green-300'}`} data-id="element-215">
      <div className="relative" data-id="element-216">
        <div className="h-32 p-4 flex items-center justify-center" data-id="element-217">
          <img src={sku.image} alt={sku.name} className="max-h-full object-contain" data-id="element-218" />
        </div>
        {isSelected && <div className="absolute top-2 right-2 bg-green-500 text-white rounded-full h-6 w-6 flex items-center justify-center" data-id="element-219">
            <CheckIcon className="h-4 w-4" data-id="element-220" />
          </div>}
      </div>
      <div className="p-4 border-t border-gray-100" data-id="element-221">
        <div className="flex justify-between items-start mb-1" data-id="element-222">
          <div className="text-xs text-gray-500" data-id="element-223">{sku.brand}</div>
          <div className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded" data-id="element-224">
            SKU: {sku.sku}
          </div>
        </div>
        <h3 className="font-medium text-gray-800 mb-1 truncate" data-id="element-225">{sku.name}</h3>
        <div className="flex justify-between items-center mb-3" data-id="element-226">
          <div className="text-sm font-medium" data-id="element-227">${sku.price}</div>
          <div className={`text-xs ${sku.stock > 10 ? 'text-green-600' : sku.stock > 0 ? 'text-orange-600' : 'text-red-600'}`} data-id="element-228">
            {sku.stock > 10 ? 'In Stock' : sku.stock > 0 ? 'Low Stock' : 'Out of Stock'}
          </div>
        </div>
        <button onClick={onToggleSelect} className={`w-full py-2 rounded-md font-medium text-sm ${isSelected ? 'bg-green-50 text-green-600 border border-green-200' : 'bg-green-600 text-white hover:bg-green-700'}`} data-id="element-229">
          {isSelected ? 'Added' : 'Add Variant'}
        </button>
      </div>
    </div>;
};